export default{
    etapas: [],
    etapaSelec: null,
}